import { render, staticRenderFns } from "./OpenMemberTips.vue?vue&type=template&id=23216426&scoped=true&"
import script from "./OpenMemberTips.vue?vue&type=script&lang=js&"
export * from "./OpenMemberTips.vue?vue&type=script&lang=js&"
import style0 from "./OpenMemberTips.vue?vue&type=style&index=0&id=23216426&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23216426",
  null
  
)

export default component.exports